import styled from 'styled-components';

export const StyledTileWrapper = styled.div`
  margin-right: 15px;
  margin-bottom: 1rem;
`;

export const StyledScrollWrapper = styled.ul`
  height: 290px;
  padding-left: 0;
  overflow-x: hidden;
  padding-right: 10px;
  ${({ theme }) => theme.scrollbar};
`;

export const StyledContainer = styled.div`
  /* Mobile Devices */
  @media (max-width: 480px) {
    overflow-x: hidden;
    max-height: calc(calc(${({ theme }) => theme.mobileViewHeight}) - 4rem);
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    overflow-x: hidden;
    max-height: calc(calc(${({ theme }) => theme.mobileViewHeight}) - 6rem);
  }
`;

export const StyledGraphWrapper = styled.div`
  height: auto;
  margin-top: 10px;
  margin-right: 15px;
  margin-bottom: 10px;

  /* Mobile Devices */
  @media (max-width: 480px) {
    margin-right: 5px;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    margin-right: 0px;
  }
`;
